import { useEffect, useState } from 'react';

import { Group, ScrollArea } from '@mantine/core';
// import { MantineLogo } from '@mantinex/mantine-logo';
// import classes from './styles.module.scss';

import "./style.css"
import { AlertTriangle, ArrowUpCircle, Bell, Briefcase, DollarSign, FileText, Image, Mail, Monitor, PenTool, Settings, Tool, User, Code, Grid } from '@geist-ui/icons';
import { LinksGroup } from './LinksGroup';
import { useAppSelector } from 'src/store';
import { useLocation } from 'react-router-dom';
import { PATHS } from 'src/constants';
import { LogoutButton } from '../Header/components';
import { apiInstance } from 'src/services';


const navigateToPayment = (): void => {
  apiInstance.get('payment/portal').then((res) => {
    // window.location = res.data.url;
    window.open(res.data.url, '_blank');
  });
};

const freePlanSideBar = [
  { label: 'Upgrade', icon: ArrowUpCircle, link: "#", title: 'Upgrade Page', ariaLabel: 'Upgrade your current plan - opens in new tab', func: () => { navigateToPayment() } },
  { label: 'Support', icon: Mail, link: PATHS.SUPPORT, title: 'Support Page', ariaLabel: 'Support Page Link - opens in new tab', links : undefined },
  { label: 'Invitations', link: PATHS.COMPANY, icon: Bell, title: 'Invitations Page', ariaLabel: 'Invitations Page Link' },
  {
    label: 'Tools',
    title: 'Tools', ariaLabel: 'Tools Options',
    icon: Tool,
    links: [
      { label: 'Color Contrast Checker', link: PATHS.TOOLS, Icon: PenTool, title: 'Color Contrast Checker Page', ariaLabel: 'Color Contrast Checker Page Link', },
      { label: 'Image Description Checker', link: PATHS.IMAGEDESCRIPTIONCHECKER, Icon: Image, title: 'Image Description Checker', ariaLabel: 'Image Description Checker Page Link', },
      // { label: 'Single Page Checker', link: PATHS.SINGLEPAGECHECKER, Icon: Monitor, title: 'Single Page Checker', ariaLabel: 'Single Page Checker Page Link', },
      // { label: 'Check Code Snippet', link: PATHS.CODEACCESSIBILITY, Icon: Code, title: 'Check Code Snippet', ariaLabel: 'Check Code Snippet Page Link', },
      { label: 'Language Level Checker', link: PATHS.LANGUAGELEVELCHECKER, Icon: FileText, title: 'Language Level Checker', ariaLabel: 'Language Level Checker Page Link', },
    ],
  },
]
const mockdata = [
  { label: 'Dashboard', icon: Grid, link: PATHS.DASHBOARD, title: 'Dashboard Overview', ariaLabel: 'Dashboard Overview' },
  { label: 'Issues', icon: AlertTriangle, link: PATHS.AUTOMATED_AUDIT_SELECT, title: 'Issues Page', ariaLabel: 'Issues Page Link' },
  { label: 'Upgrade', icon: ArrowUpCircle, link: "#", title: 'Upgrade Page', ariaLabel: 'Upgrade your current plan - opens in new tab', func: () => { navigateToPayment() } },

  {
    label: 'Settings',
    icon: Settings,
    title: 'Settings', ariaLabel: 'Settings Options',
    links: [
      { label: 'Account', link: PATHS.ACCOUNT_PAGE, Icon: User, title: 'Account Page', ariaLabel: 'Account  Page Link', },
      { label: 'Companies', link: PATHS.ORGANIZATION, Icon: Briefcase, title: 'Companies Page', ariaLabel: 'Companies Page Link' },
      { label: 'Invitations', link: PATHS.COMPANY, Icon: Bell, title: 'Invitations Page', ariaLabel: 'Invitations Page Link' },
      // { label: 'Billing', link: PATHS.BILLINGPAGE, Icon: DollarSign, title: 'Billing Page', ariaLabel: 'Billing Page Link' },
    ],
  },
  { label: 'Support', icon: Mail, link: PATHS.SUPPORT, title: 'Support Page', ariaLabel: 'Support Page Link - opens in new tab', },
  {
    label: 'Tools',
    title: 'Tools', ariaLabel: 'Tools Options',
    icon: Tool,
    links: [
      { label: 'Color Contrast Checker', link: PATHS.TOOLS, Icon: PenTool, title: 'Color Contrast Checker Page', ariaLabel: 'Color Contrast Checker Page Link', },
      { label: 'Image Description Checker', link: PATHS.IMAGEDESCRIPTIONCHECKER, Icon: Image, title: 'Image Description Checker', ariaLabel: 'Image Description Checker Page Link', },
      { label: 'Single Page Checker', link: PATHS.SINGLEPAGECHECKER, Icon: Monitor, title: 'Single Page Checker', ariaLabel: 'Single Page Checker Page Link', },
      { label: 'Check Code Snippet', link: PATHS.CODEACCESSIBILITY, Icon: Code, title: 'Check Code Snippet', ariaLabel: 'Check Code Snippet Page Link', },
      { label: 'Language Level Checker', link: PATHS.LANGUAGELEVELCHECKER, Icon: FileText, title: 'Language Level Checker', ariaLabel: 'Language Level Checker Page Link', },
    ],
  },
];

export default function NavbarSimple() {
  const { data } = useAppSelector((state) => state.payment);

  const navList = ['free', 'free plan'].includes(data?.paymentPlan) ? freePlanSideBar : mockdata;
  const links = navList.map((item) => {
    return (
      <LinksGroup
        link={item.link}
        key={item.label}
        icon={item.icon}
        label={item.label}
        links={item.links ?? undefined}
        title={item.title}
        ariaLabel={item.ariaLabel}
        func={item?.func ?? undefined}
      />
    )
  })

  return (
    <nav className={'navbar'}>
      {/* <div className={'navbarMain'}>
       {links}
      </div> */}
      <ScrollArea className={'links'}>
        <div className={'linksInner'}>{links}</div>
      </ScrollArea>
    </nav>
  );
}